if (!customElements.get('product-drawer')) {
  class ProductDrawer extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.product-drawer__trigger');
      this.container = this.querySelector('.product-drawer-container');
      this.closeBtn = this.querySelector('.product-drawer__close');
      this.overlay = this.querySelector('.product-drawer__overlay');

      if (this.trigger) {
        this.trigger.addEventListener('click', this.open.bind(this));
      }

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this.close.bind(this));
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', this.close.bind(this));
      }

      // Handle Escape key (global listener)
      this._onKeyUp = (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.close();
      };
    }

    connectedCallback() {
      // Ensure the container is in the body for proper z-index/positioning
      if (this.container && this.container.parentNode !== document.body) {
        document.body.appendChild(this.container);
      }
      document.addEventListener('keyup', this._onKeyUp);
    }

    disconnectedCallback() {
      if (this.container && this.container.parentNode === document.body) {
        document.body.removeChild(this.container);
      }
      document.removeEventListener('keyup', this._onKeyUp);
    }

    open() {
      // Close any other open product drawers first
      document.querySelectorAll('.product-drawer-container.active').forEach(drawer => {
        drawer.classList.remove('active');
      });

      this.container.classList.add('active');
      document.body.classList.add('overflow-hidden');
      this.container.setAttribute('aria-hidden', 'false');
      
      // Prevent focus from going outside the drawer
      if (typeof trapFocus === 'function') {
        trapFocus(this.container.querySelector('.product-drawer__inner'));
      }
    }

    close() {
      this.container.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      this.container.setAttribute('aria-hidden', 'true');
      
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.trigger);
      }
    }
  }

  customElements.define('product-drawer', ProductDrawer);
}
